<template>
  <div
    v-scroll="onScroll"
    class="v-gallery"
  >
    <v-container
      :fluid="!isScrolling"
      class="transition-swing"
    >
      <v-row
        :no-gutters="!isScrolling"
        class="transition-swing mx-n4"
      >
        <v-col
          v-for="(pic, i) in paginatedPictures"
          :key="pic.srcThumb"
          cols="12"
          md="4"
          class="transition-swing"
        >
          <gallery-card
            :src="pic.srcThumb"
            @click.stop="setPicture(i)"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-responsive
      v-if="paginatedPictures.length < pictures.length"
      class="white py-12 pl-10 mx-n3 text-center"
    >
      <v-btn
        v-if="page === 1"
        text
        @click="page++"
      >
        Больше фото
      </v-btn>
    </v-responsive>

    <gallery-carousel-home v-model="dialog" />
  </div>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'
  export default {
    name: 'GalleryHome',
    components: {
      GalleryCard: () => import('@/components/GalleryCard'),
      GalleryCarouselHome: () => import('@/components/GalleryCarouselHome'),
    },
    data: () => ({
      dialog: false,
      isScrolling: false,
      page: 1,
    }),
    computed: {
      ...sync('photographs', [
        'filter',
        'picture',
        'pagPictures',
      ]),
      pictures: get('photographs/pictures'),
      filteredPictures () {
        return this.pictures
      },
      paginatedPictures () {
        return this.filteredPictures.slice(0, this.page * 6)
      },
    },
    methods: {
      onScroll () {
        this.isScrolling = window.pageYOffset > 50
      },
      setPicture (index) {
        this.picture = index
        this.pagPictures = this.paginatedPictures
        this.$nextTick(() => (this.dialog = true))
      },
    },
  }
</script>

<style lang="sass">
  .gallery
  // max-width: 1280px
</style>
